// frontend/src/pages/Login.jsx
import React, {useEffect, useState} from 'react';
import {
    Alert,
    Box,
    Button,
    Checkbox,
    Container,
    Divider,
    FormControlLabel,
    Paper,
    TextField,
    Typography
} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useAuth} from "../../context/AuthContext";
import Logo from "../../assets/logo inverted.png";

export default function Login() {
    const navigate = useNavigate();
    const {user, login} = useAuth();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [remember, setRemember] = useState(false);

    const handleLogin = async (e) => {
        setLoading(true);
        e.preventDefault();
        setError('');

        if (!e.currentTarget.checkValidity()) {
            e.currentTarget.reportValidity();
            setLoading(false);
            return;
        }

        const formData = new FormData(e.currentTarget);
        const email = formData.get('email');
        const password = formData.get('password');

        const result = await login(email, password, remember);

        if (result.success) {
            navigate('/');
        } else {
            setError(result.message || 'Échec de la connexion.');
        }

        setLoading(false);
    };

    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate])

    return (
        <Container maxWidth="sm"
                   sx={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Paper elevation={6} sx={{p: 4, width: '100%'}}>
                <Box sx={{textAlign: 'center', mb: 3}}>
                    <img src={Logo} alt={'logo'} style={{width: "100%"}}/>
                    <Typography variant="body1" color="text.secondary">
                        Connectez-vous pour accéder à votre espace.
                    </Typography>
                </Box>

                <Divider sx={{mb: 3}}/>

                {error && (
                    <Alert severity="error" sx={{mb: 2}}>
                        {error}
                    </Alert>
                )}

                <Box component="form" onSubmit={handleLogin} sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                    <TextField name="email" label="Adresse mail" variant="outlined" fullWidth required/>
                    <TextField name="password" label="Mot de passe" type="password" variant="outlined" fullWidth
                               required/>

                    <Box
                        sx={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column'}}>
                        <Button size="small" color="secondary" onClick={() => navigate('/forgot-password')}
                                sx={{ml: 'auto'}}>
                            Mot de passe oublié ?
                        </Button>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="remember"
                                    checked={remember}
                                    onChange={(e) => setRemember(e.target.checked)}
                                />
                            }
                            label="Se souvenir de moi"
                        />
                    </Box>

                    <Button type="submit" variant="contained" size="large" sx={{mt: 1}} disabled={loading}>
                        Connexion
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}